import { ProviderBuilder, EGenMode } from '@educraft/base';
import { BludisteSpoj } from './generators/BludisteSpoj';
import { MiniLUK__Groups } from './generators/MiniLUK';
import { MathPath__Base, MathPath__Diagonal, MathPath__Small } from './generators/MathPath';
import { HraPostupne } from './generators/HraPostupne';
import { Pisemka } from './generators/Pisemka';
import { ZHlavy } from './generators/ZHlavy';
import {
  HodKostkouVybarvi__1,
  HodKostkouVybarvi__2,
  HodKostkouVybarvi__3,
} from './generators/RollDiceFill';

export function registerLayoutSingle(builder: ProviderBuilder) {
  builder.add(EGenMode.LayoutSingle, BludisteSpoj, 'Single.BludisteSpoj');
  builder.add(EGenMode.LayoutSingle, MathPath__Base, 'Single.MathPath__Base');
  builder.add(EGenMode.LayoutSingle, MathPath__Diagonal, 'Single.MathPath__Diagonal');
  builder.add(EGenMode.LayoutSingle, MathPath__Small, 'Single.MathPath__Small');
  builder.add(EGenMode.LayoutSingle, MiniLUK__Groups, 'Single.MiniLUK__Groups');
  builder.add(EGenMode.LayoutSingle, HraPostupne, 'Single.HraPostupne');
  builder.add(EGenMode.LayoutSingle, Pisemka, 'Single.Pisemka');
  builder.add(EGenMode.LayoutSingle, ZHlavy, 'Single.ZHlavy');

  builder.add(EGenMode.LayoutSingle, HodKostkouVybarvi__1, 'Single.HodKostkouVybarvi__1');
  builder.add(EGenMode.LayoutSingle, HodKostkouVybarvi__2, 'Single.HodKostkouVybarvi__2');
  builder.add(EGenMode.LayoutSingle, HodKostkouVybarvi__3, 'Single.HodKostkouVybarvi__3');
}
